(()=>{
 const init=()=>{
  const collector=document.querySelector('.pk-product-collector');
  const media=collector?.querySelector('.product__media-wrapper');
  if(!media)return;
  const stories=[...document.querySelectorAll('[data-pk-buyer-showcase],section#customer-story')].filter(e=>!e.closest('[id^="PKCustomerStories-"]'));
  const faq=document.querySelector('[data-pk-dzi-faq]');
  if(!stories.length&&!faq)return;
  collector.classList.add('pk-product-buyer-layout');
  const place=()=>{
   const faq=document.querySelector('.pk-dzi-integrated [data-pk-dzi-faq]')||document.querySelector('[data-pk-dzi-faq]');
   if(faq)document.querySelectorAll('[data-pk-dzi-faq]').forEach(other=>{
    if(other!==faq&&other.getAttribute('aria-labelledby')===faq.getAttribute('aria-labelledby'))other.remove();
   });
   const stories=[...document.querySelectorAll('[data-pk-buyer-showcase],section#customer-story')].filter(e=>!e.closest('[id^="PKCustomerStories-"]'));
   const film=document.querySelector('.pk-dzi-film');
   if(film){let previous=film;stories.forEach(story=>{if(previous.nextElementSibling!==story)previous.after(story);previous=story;});}
   else stories.forEach(story=>{if(story.parentElement!==media)media.append(story);});
   const anchor=stories.at(-1)||film;
   const faqHost=document.querySelector('[id^="PKCustomerStories-"] > .page-width');
   if(faq&&faqHost){if(faq.parentElement!==faqHost||faqHost.lastElementChild!==faq)faqHost.append(faq);}
   else if(faq){if(anchor){if(anchor.nextElementSibling!==faq)anchor.after(faq);}else if(faq.parentElement!==media)media.append(faq);}
  };
  place();
  if(!collector.dataset.buyerLayoutReady){
   collector.dataset.buyerLayoutReady='true';
   matchMedia('(min-width:750px)').addEventListener('change',()=>requestAnimationFrame(place));
   window.addEventListener('resize',()=>requestAnimationFrame(place),{passive:true});
   let queued=false;
   const observer=new MutationObserver(()=>{if(!queued){queued=true;requestAnimationFrame(()=>{queued=false;place();});}});
   observer.observe(collector,{childList:true,subtree:true});
   const editorial=document.querySelector('.pk-dzi-integrated');
   if(editorial)observer.observe(editorial,{childList:true,subtree:true});
  }
  stories.forEach(story=>{
   story.classList.add('pk-product-buyer-stories');
   if(story.dataset.buyerCarouselReady)return;
   const first=story.querySelector('article,figure');
   const track=first?.parentElement;
   if(!track)return;
   track.classList.add('pk-product-buyer-track');
   const cards=[...track.children].filter(e=>e.matches('article,figure'));
   cards.forEach(e=>e.classList.add('pk-product-buyer-card'));
   story.dataset.buyerCarouselReady='true';
   if(cards.length<2)return;
   track.tabIndex=0;
   track.setAttribute('aria-label','Customer stories for this piece');
   const controls=document.createElement('div');controls.className='pk-product-buyer-controls';
   const prev=document.createElement('button'),next=document.createElement('button'),status=document.createElement('span');
   prev.type=next.type='button';prev.textContent='←';next.textContent='→';
   prev.setAttribute('aria-label','Previous customer story');next.setAttribute('aria-label','Next customer story');
   status.setAttribute('aria-live','polite');controls.append(prev,status,next);track.after(controls);
   const update=()=>{const index=Math.max(0,Math.min(cards.length-1,Math.round(track.scrollLeft/(track.clientWidth+14))));status.textContent=`${index+1} / ${cards.length}`;prev.disabled=index===0;next.disabled=index===cards.length-1;};
   const move=direction=>track.scrollBy({left:direction*(track.clientWidth+14),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
   prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
   track.addEventListener('scroll',update,{passive:true});
   track.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
   new ResizeObserver(update).observe(track);update();
  });
 };
 const schedule=()=>requestAnimationFrame(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
 document.addEventListener('shopify:section:load',schedule);
})();
